// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v1PublicGetAmmMarket (params?: {}): Promise<Dict>;
    v1PublicGetCommonCurrencyRate (params?: {}): Promise<Dict>;
    v1PublicGetCommonAssetConfig (params?: {}): Promise<Dict>;
    v1PublicGetCommonMaintainInfo (params?: {}): Promise<Dict>;
    v1PublicGetCommonTempMaintainInfo (params?: {}): Promise<Dict>;
    v1PublicGetMarginMarket (params?: {}): Promise<Dict>;
    v1PublicGetMarketInfo (params?: {}): Promise<Dict>;
    v1PublicGetMarketList (params?: {}): Promise<Dict>;
    v1PublicGetMarketTicker (params?: {}): Promise<Dict>;
    v1PublicGetMarketTickerAll (params?: {}): Promise<Dict>;
    v1PublicGetMarketDepth (params?: {}): Promise<Dict>;
    v1PublicGetMarketDeals (params?: {}): Promise<Dict>;
    v1PublicGetMarketKline (params?: {}): Promise<Dict>;
    v1PublicGetMarketDetail (params?: {}): Promise<Dict>;
    v1PrivateGetAccountAmmBalance (params?: {}): Promise<Dict>;
    v1PrivateGetAccountInvestmentBalance (params?: {}): Promise<Dict>;
    v1PrivateGetAccountBalanceHistory (params?: {}): Promise<Dict>;
    v1PrivateGetAccountMarketFee (params?: {}): Promise<Dict>;
    v1PrivateGetBalanceCoinDeposit (params?: {}): Promise<Dict>;
    v1PrivateGetBalanceCoinWithdraw (params?: {}): Promise<Dict>;
    v1PrivateGetBalanceInfo (params?: {}): Promise<Dict>;
    v1PrivateGetBalanceDepositAddressCoinType (params?: {}): Promise<Dict>;
    v1PrivateGetContractTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetCreditInfo (params?: {}): Promise<Dict>;
    v1PrivateGetCreditBalance (params?: {}): Promise<Dict>;
    v1PrivateGetInvestmentTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetMarginAccount (params?: {}): Promise<Dict>;
    v1PrivateGetMarginConfig (params?: {}): Promise<Dict>;
    v1PrivateGetMarginLoanHistory (params?: {}): Promise<Dict>;
    v1PrivateGetMarginTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetOrderDeals (params?: {}): Promise<Dict>;
    v1PrivateGetOrderFinished (params?: {}): Promise<Dict>;
    v1PrivateGetOrderPending (params?: {}): Promise<Dict>;
    v1PrivateGetOrderStatus (params?: {}): Promise<Dict>;
    v1PrivateGetOrderStatusBatch (params?: {}): Promise<Dict>;
    v1PrivateGetOrderUserDeals (params?: {}): Promise<Dict>;
    v1PrivateGetOrderStopFinished (params?: {}): Promise<Dict>;
    v1PrivateGetOrderStopPending (params?: {}): Promise<Dict>;
    v1PrivateGetOrderUserTradeFee (params?: {}): Promise<Dict>;
    v1PrivateGetOrderMarketTradeInfo (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountBalance (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountAuthApi (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountAuthApiUserAuthId (params?: {}): Promise<Dict>;
    v1PrivatePostBalanceCoinWithdraw (params?: {}): Promise<Dict>;
    v1PrivatePostContractBalanceTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostMarginFlat (params?: {}): Promise<Dict>;
    v1PrivatePostMarginLoan (params?: {}): Promise<Dict>;
    v1PrivatePostMarginTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostOrderLimitBatch (params?: {}): Promise<Dict>;
    v1PrivatePostOrderIoc (params?: {}): Promise<Dict>;
    v1PrivatePostOrderLimit (params?: {}): Promise<Dict>;
    v1PrivatePostOrderMarket (params?: {}): Promise<Dict>;
    v1PrivatePostOrderModify (params?: {}): Promise<Dict>;
    v1PrivatePostOrderStopLimit (params?: {}): Promise<Dict>;
    v1PrivatePostOrderStopMarket (params?: {}): Promise<Dict>;
    v1PrivatePostOrderStopModify (params?: {}): Promise<Dict>;
    v1PrivatePostSubAccountTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostSubAccountRegister (params?: {}): Promise<Dict>;
    v1PrivatePostSubAccountUnfrozen (params?: {}): Promise<Dict>;
    v1PrivatePostSubAccountFrozen (params?: {}): Promise<Dict>;
    v1PrivatePostSubAccountAuthApi (params?: {}): Promise<Dict>;
    v1PrivatePutBalanceDepositAddressCoinType (params?: {}): Promise<Dict>;
    v1PrivatePutSubAccountUnfrozen (params?: {}): Promise<Dict>;
    v1PrivatePutSubAccountFrozen (params?: {}): Promise<Dict>;
    v1PrivatePutSubAccountAuthApiUserAuthId (params?: {}): Promise<Dict>;
    v1PrivatePutV1AccountSettings (params?: {}): Promise<Dict>;
    v1PrivateDeleteBalanceCoinWithdraw (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderPendingBatch (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderPending (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderStopPending (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderStopPendingId (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderPendingByClientId (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrderStopPendingByClientId (params?: {}): Promise<Dict>;
    v1PrivateDeleteSubAccountAuthApiUserAuthId (params?: {}): Promise<Dict>;
    v1PrivateDeleteSubAccountAuthorizeId (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetPing (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetTime (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketList (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketLimitConfig (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketTicker (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketTickerAll (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketDepth (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketDeals (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketFundingHistory (params?: {}): Promise<Dict>;
    v1PerpetualPublicGetMarketKline (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetMarketUserDeals (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetAssetQuery (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderPending (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderFinished (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderStopFinished (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderStopPending (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderStatus (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetOrderStopStatus (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionFinished (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionPending (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionFunding (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionAdlHistory (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetMarketPreference (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionMarginHistory (params?: {}): Promise<Dict>;
    v1PerpetualPrivateGetPositionSettleHistory (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostMarketAdjustLeverage (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostMarketPositionExpect (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderPutLimit (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderPutMarket (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderPutStopLimit (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderPutStopMarket (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderModify (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderModifyStop (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancel (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelAll (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelBatch (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelStop (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelStopAll (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCloseLimit (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCloseMarket (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostPositionAdjustMargin (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostPositionStopLoss (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostPositionTakeProfit (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostPositionMarketClose (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelByClientId (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostOrderCancelStopByClientId (params?: {}): Promise<Dict>;
    v1PerpetualPrivatePostMarketPreference (params?: {}): Promise<Dict>;
    v2PublicGetMaintainInfo (params?: {}): Promise<Dict>;
    v2PublicGetPing (params?: {}): Promise<Dict>;
    v2PublicGetTime (params?: {}): Promise<Dict>;
    v2PublicGetSpotMarket (params?: {}): Promise<Dict>;
    v2PublicGetSpotTicker (params?: {}): Promise<Dict>;
    v2PublicGetSpotDepth (params?: {}): Promise<Dict>;
    v2PublicGetSpotDeals (params?: {}): Promise<Dict>;
    v2PublicGetSpotKline (params?: {}): Promise<Dict>;
    v2PublicGetSpotIndex (params?: {}): Promise<Dict>;
    v2PublicGetFuturesMarket (params?: {}): Promise<Dict>;
    v2PublicGetFuturesTicker (params?: {}): Promise<Dict>;
    v2PublicGetFuturesDepth (params?: {}): Promise<Dict>;
    v2PublicGetFuturesDeals (params?: {}): Promise<Dict>;
    v2PublicGetFuturesKline (params?: {}): Promise<Dict>;
    v2PublicGetFuturesIndex (params?: {}): Promise<Dict>;
    v2PublicGetFuturesFundingRate (params?: {}): Promise<Dict>;
    v2PublicGetFuturesFundingRateHistory (params?: {}): Promise<Dict>;
    v2PublicGetFuturesPremiumIndexHistory (params?: {}): Promise<Dict>;
    v2PublicGetFuturesPositionLevel (params?: {}): Promise<Dict>;
    v2PublicGetFuturesLiquidationHistory (params?: {}): Promise<Dict>;
    v2PublicGetFuturesBasisHistory (params?: {}): Promise<Dict>;
    v2PublicGetAssetsDepositWithdrawConfig (params?: {}): Promise<Dict>;
    v2PublicGetAssetsAllDepositWithdrawConfig (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubs (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsApiDetail (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsInfo (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsApi (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsTransferHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAccountSubsSpotBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAccountTradeFeeRate (params?: {}): Promise<Dict>;
    v2PrivateGetAccountFuturesMarketSettings (params?: {}): Promise<Dict>;
    v2PrivateGetAccountInfo (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsSpotBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsFuturesBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsMarginBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsFinancialBalance (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsAmmLiquidity (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsCreditInfo (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsSpotTranscationHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsMarginBorrowHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsMarginInterestLimit (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsDepositAddress (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsDepositHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsWithdraw (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsTransferHistory (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsAmmLiquidityPool (params?: {}): Promise<Dict>;
    v2PrivateGetAssetsAmmIncomeHistory (params?: {}): Promise<Dict>;
    v2PrivateGetSpotOrderStatus (params?: {}): Promise<Dict>;
    v2PrivateGetSpotBatchOrderStatus (params?: {}): Promise<Dict>;
    v2PrivateGetSpotPendingOrder (params?: {}): Promise<Dict>;
    v2PrivateGetSpotFinishedOrder (params?: {}): Promise<Dict>;
    v2PrivateGetSpotPendingStopOrder (params?: {}): Promise<Dict>;
    v2PrivateGetSpotFinishedStopOrder (params?: {}): Promise<Dict>;
    v2PrivateGetSpotUserDeals (params?: {}): Promise<Dict>;
    v2PrivateGetSpotOrderDeals (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesOrderStatus (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesBatchOrderStatus (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPendingOrder (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesFinishedOrder (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPendingStopOrder (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesFinishedStopOrder (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesUserDeals (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesOrderDeals (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPendingPosition (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesFinishedPosition (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPositionMarginHistory (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPositionFundingHistory (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPositionAdlHistory (params?: {}): Promise<Dict>;
    v2PrivateGetFuturesPositionSettleHistory (params?: {}): Promise<Dict>;
    v2PrivateGetReferReferee (params?: {}): Promise<Dict>;
    v2PrivateGetReferRefereeRebateRecord (params?: {}): Promise<Dict>;
    v2PrivateGetReferRefereeRebateDetail (params?: {}): Promise<Dict>;
    v2PrivateGetReferAgentReferee (params?: {}): Promise<Dict>;
    v2PrivateGetReferAgentRebateRecord (params?: {}): Promise<Dict>;
    v2PrivateGetReferAgentRebateDetail (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubs (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsFrozen (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsUnfrozen (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsApi (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsEditApi (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsDeleteApi (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSubsTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostAccountSettings (params?: {}): Promise<Dict>;
    v2PrivatePostAccountFuturesMarketSettings (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsMarginBorrow (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsMarginRepay (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsRenewalDepositAddress (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsWithdraw (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsCancelWithdraw (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsTransfer (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsAmmAddLiquidity (params?: {}): Promise<Dict>;
    v2PrivatePostAssetsAmmRemoveLiquidity (params?: {}): Promise<Dict>;
    v2PrivatePostSpotOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotBatchOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotBatchStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotModifyOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotModifyStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotBatchModifyOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelAllOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelBatchOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelBatchStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelOrderByClientId (params?: {}): Promise<Dict>;
    v2PrivatePostSpotCancelStopOrderByClientId (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesBatchOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesBatchStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelPositionStopLoss (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelPositionTakeProfit (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesModifyOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesModifyStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesBatchModifyOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelAllOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelBatchOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelBatchStopOrder (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelOrderByClientId (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesCancelStopOrderByClientId (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesClosePosition (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesAdjustPositionMargin (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesAdjustPositionLeverage (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesSetPositionStopLoss (params?: {}): Promise<Dict>;
    v2PrivatePostFuturesSetPositionTakeProfit (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
